module.exports = __webpack_public_path__ + "img/5.7421d3d7.webp";